import {
    BADGE_CLASS,
    PAGE_BUILDER_PRICE_SELECTOR,
    PRICE_SELECTOR,
    PRODUCT_NODE_SELECTOR,
    PROCESSED_ATTR,
} from './constants';
import { normalizeMultiplier, parseNumber } from './helpers';
import { getProductPath } from './product-path';
import { bindHoverState, createBadgeElement, revealBadge, setBadgeContent } from './render';

function getBadgeSource(container) {
    return container.matches(PAGE_BUILDER_PRICE_SELECTOR) ? 'page-builder' : 'theme';
}

function getThemeBadgeData(container) {
    const templateBadge = container.querySelector('.entries-product-badge[data-entries-from-template="true"]');

    if (!templateBadge) {
        return null;
    }

    const price = parseNumber(templateBadge.dataset.entriesPrice);

    if (Number.isNaN(price) || price <= 0) {
        return null;
    }

    const multiplierValue = normalizeMultiplier(parseNumber(templateBadge.dataset.entriesMultiplier));

    return {
        totalEntries: price * multiplierValue,
        multiplier: multiplierValue,
    };
}

function addBadgeToContainer(container, storefrontApiToken) {
    const nextSibling = container.nextElementSibling;

    if (container.hasAttribute(PROCESSED_ATTR) || (nextSibling && nextSibling.classList.contains(BADGE_CLASS))) {
        container.setAttribute(PROCESSED_ATTR, 'true');
        return;
    }

    const source = getBadgeSource(container);
    const badge = createBadgeElement(source);
    const productPath = getProductPath(container);

    if (productPath) {
        badge.dataset.productPath = productPath;
    }

    if (source === 'page-builder') {
        badge.dataset.storefrontTokenReady = String(Boolean(storefrontApiToken));
    } else {
        const badgeData = getThemeBadgeData(container);

        if (!badgeData) {
            container.setAttribute(PROCESSED_ATTR, 'true');
            return;
        }

        setBadgeContent(badge, badgeData);
    }

    container.insertAdjacentElement('afterend', badge);
    container.setAttribute(PROCESSED_ATTR, 'true');
    bindHoverState(container, badge);

    if (source === 'theme') {
        revealBadge(badge);
    }
}

export function processPriceContainers(containers, storefrontApiToken) {
    containers.forEach((container) => {
        if (!container) {
            return;
        }

        addBadgeToContainer(container, storefrontApiToken);
    });
}

export function getPriceContainers(root = document) {
    return Array.from(root.querySelectorAll(`${PRICE_SELECTOR}:not([${PROCESSED_ATTR}])`));
}

export function collectPriceContainersFromNode(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) {
        return [];
    }

    const containers = [];

    if (node.matches(PRICE_SELECTOR)) {
        containers.push(node);
    }

    if (node.matches(PRODUCT_NODE_SELECTOR) || node.querySelector(PRICE_SELECTOR)) {
        containers.push(...getPriceContainers(node));
    }

    return containers;
}
